export default __webpack_public_path__ + "static/media/part.ca0acf43.jpg";